<template>
    <div class="card h-100 rounded-0 border-0" :class="animation">
        <div class="card-body text-center h-100 p-0">
            <div class="row">
                <BackButton @click.native="handleBackToStep()" />
            </div>
            <div class="row mb-5">
                <div class="form-wrap-step">
                    <div>
                        <h5 class="title__normal">作業場所の階数を選択してください。</h5>
                    </div>
                </div>
            </div>
            <div class="form-wrap-step">
                <div class="row">
                    <div class="col-md-3"></div>
                    <div class="col-md-6">
                        <div class="d-flex justify-content-center mb-1">
                            <input 
                                min="0"
                                oninput="validity.valid||(value='')"
                                type="number" 
                                class="form-control rounded-0 text-center in-below-adv" 
                                style="width: 10rem;"
                                name="numberOfStorey"
                                v-model="numberOfStorey"
                                @input="onChange($event)"
                            />
                            <span class="col-form-label pl-0 ml-3 label1 lb-below-adv">階数</span>
                        </div>
                        <span 
                            v-if="!$v.numberOfStorey.required && $v.numberOfStorey.$dirty" 
                            class="help-block error-help-block d-block" >階数は入力必須です
                        </span>
                        <span 
                            v-if="!$v.numberOfStorey.minValue && $v.numberOfStorey.$dirty" 
                            class="help-block error-help-block d-block" >１以上の整数を入力してください
                        </span>
                        <span 
                            v-if="!$v.numberOfStorey.maxValue && $v.numberOfStorey.$dirty" 
                            class="help-block error-help-block d-block" >99までの数値で入力してください
                        </span>
                    </div>
                    <div class="col-md-3">
                    </div>
                </div>
                <h5 class="mt-5 mb-4 title__normal">エレベーターはありますか？</h5>
                <div class="row mb-3">
                    <div class="col-md-12 below-adv-btn">
                        <button class="btn btn-yellow-dark px-4 d-inline-block btn-lg rounded-1" @click="handleClick(IS_ELEVATOR)">
                            <span class="text">はい</span>
                        </button>
                        <button class="btn btn-yellow-dark px-4 d-inline-block btn-lg rounded-1" @click="handleClick(NO_ELEVATOR)">
                            <span class="text">いいえ</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { required, maxValue, minValue } from 'vuelidate/lib/validators';
    import BackButton from './BackButton.vue';

    export default {
    name: 'NumberOfStorey',
    props: {
        allData: {
            default: ''
        },
        animation: {
            default: ''
        },
        followStep: {
            default: ''
        },
        formValue: {
            numberOfStorey: ''
        }
    },
    data() {
        return {
            IS_ELEVATOR: 1,
            NO_ELEVATOR: 0,
            numberOfStorey: this.formValue.numberOfStorey,
            data: {},
            FOLLOW_OVERSIZED: 1,
            FOLLOW_APPLIANCE: 2,
            IS_COLLECT: 1,
        };
    },
    validations: {
        numberOfStorey: {
            required,
            minValue: minValue(1),
            maxValue: maxValue(99),
        },
    },
    methods: {
        onChange(e) {
            let payload = {
                label: (this.followStep === this.FOLLOW_OVERSIZED) ? 'trashOversized' : 'trashAppliance',
                data: {
                    ...this.formValue,
                    [e.target.name]: e.target.value
                }
            };
            this.$emit('onChangeFormValue', payload);
        },
        validate() {
            this.$v.$touch();
        },
        async handleClick(option) { 
            this.validate();
            if(!this.$v.$invalid) {
                if (option === this.IS_ELEVATOR) {
                    this.data = {
                        ...this.allData,
                        is_collect: this.IS_COLLECT,
                        is_elevator: this.IS_ELEVATOR,
                    }
                } else {
                    this.data = {
                        ...this.allData,
                        is_collect: this.IS_COLLECT,
                        is_elevator: this.NO_ELEVATOR,
                    }
                }
                let res = await axios.post(`/api/register/register-info/`, this.data);
                if (res.data.success) {
                    window.location.href = '/order/order-oversized-step-company';
                } else {
                    alert('Failed to continue');
                }
            }
        },
        handleBackToStep() {
            if (this.followStep === this.FOLLOW_OVERSIZED) {
                const currentStep = 3;
                const followStep = 1;
                this.$emit("handleChangeStep", currentStep, followStep);
            }
            if (this.followStep === this.FOLLOW_APPLIANCE) {
                const currentStep = 2;
                const followStep = 2;
                this.$emit("handleChangeStep", currentStep, followStep);
            }
        },
    },
    components: { 
        BackButton 
    }
}
</script>